export default class Form {
  constructor(formId, fields) {
    this.formId = formId;
    this.fields = fields;
  }
  submit(request) {
    let url =
      "https://docs.google.com/forms/d/e/" + this.formId + "/formResponse?";
    for (const fieldID in this.fields) {
      if (request[this.fields[fieldID]]) {
        url += `&${fieldID}=${encodeURIComponent(
          request[this.fields[fieldID]]
        )}`;
      }
    }

    return fetch(url, {
      method: "GET",
      mode: "no-cors",
      redirect: "follow",
      referrer: "no-referrer",
    });
  }
}
